import { getTryRate } from "@utils/currency"
import { useEffect, useRef, useState } from "react"

/** USD→TRY rate for cost readouts; 0 means "no conversion available". */
export function useTryRate(): number {
  const [rate, setRate] = useState(0)
  const fetchedRef = useRef(false)

  useEffect(() => {
    if (fetchedRef.current) return
    fetchedRef.current = true
    getTryRate()
      .then(setRate)
      .catch(() => setRate(0))
  }, [])

  return rate
}
